import TableTitle, { TableAction } from './TableTitle'
import TableContainer from './TableContainer'
import TableContent from './TableContent'
import type { SxProps } from "@mui/system"
import { DataManager } from './DataManager'
import { ReactNode } from 'react'
import { Column, DataOrPromise, GenericRow, Options } from './types'

export default function SimpleTable<RowType extends GenericRow>({
  columns,
  data,
  title,
  actions = [],
  rowActions = [],
  options = {},
  dataManagerRef,
  onChangeColumns,
  onChange,
  hasTabNavigation = false,
  tableTitleChildren = null,
  sx = null
} : {
  columns: Column<RowType>[],
  data: DataOrPromise<RowType>,
  title?: string,
  actions: TableAction[],
  rowActions?: unknown[],
  options: Options,
  dataManagerRef?: React.Ref<DataManager<RowType>>,
  onChangeColumns?: (columns: Column<RowType>[]) => void,
  onChange?: () => void,
  hasTabNavigation?: boolean,
  tableTitleChildren?: ReactNode,
  sx?: SxProps,
}) {
  return (
    <TableContainer
      columns={columns}
      data={data}
      options={options}
      dataManagerRef={dataManagerRef}
      onChangeColumns={onChangeColumns}
      onChange={onChange}
      hasTabNavigation={hasTabNavigation}
      sx={sx}
    >
      <TableTitle title={title} columnsButton={options.columnsButton} refreshButton={options.refreshButton} refresh={options.refresh} actions={actions}>
        {tableTitleChildren}
      </TableTitle>
      <TableContent
        title={title}
        rowActions={rowActions}
        options={options}
      />
    </TableContainer>
  )
}
